
import { Assessment } from "@/interfaces/recruiter/candidates/create_assessment";
import { FETCH_AI_ASSESSMENT_QUESTIONS } from "@/store/modules/recruiter/constants";
import { AssessmentQuestion } from "@/store/modules/recruiter/interfaces";
import Vue from "vue";
import { mapGetters } from "vuex";
import QuestionsList from "./QuestionsList.vue";

export default Vue.extend({
  name: "AssessmentViewModal",
  components: {
    QuestionsList
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    assessment: {
      type: Object as () => Assessment,
      default: null
    }
  },
  data() {
    return {
      questions: [] as AssessmentQuestion[],
      page: 1,
      limit: 10,
      total: 0,
      loading: false
    };
  },
  computed: {
    ...mapGetters("recruiter", [FETCH_AI_ASSESSMENT_QUESTIONS]),
    showModal: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit("input", false);
    },
    getDifficultyColor(difficulty: string): string {
      switch (difficulty) {
        case "easy":
          return "green";
        case "medium":
          return "orange";
        case "hard":
          return "red";
        default:
          return "grey";
      }
    },
    async fetch_ai_assessment_questions() {
      this.loading = true;
      const response = await this.$store.dispatch(
        "recruiter/FETCH_AI_ASSESSMENT_QUESTIONS",
        {
          assessmentId: this.assessment.id,
          query: { page: this.page, limit: this.limit }
        }
      );
      const { results = [], total = 0 } = response?.data || {};

      this.questions = results;
      this.total = total;
      this.loading = false;
    },
    onPageChange(page: number) {
      this.page = page;
      this.fetch_ai_assessment_questions();
    },
    onLimitChange(limit: number) {
      this.limit = limit;
      this.page = 1; // Reset to first page when changing limit
      this.fetch_ai_assessment_questions();
    }
  },

  watch: {
    assessment: {
      handler() {
        this.page = 1;
        this.limit = 10;
        this.questions = [];
        this.total = 0;
        this.loading = false;
        this.fetch_ai_assessment_questions();
      },
      deep: true
    }
  }
});
